<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      show: true,
    };
  },
  created() {
    // console.log(JSON.stringify(this.$route.query));
    // 初始化渠道
  },
  beforeCreate() {},
};
</script>

<style lang="scss">
#app {
  font-family: "Segoe UI", "Open Sans", "Rubik", "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

</style>



// WEBPACK FOOTER //
// src/App.vue